/**
 * BuLeaderboardCard.jsx — Phase 121 — Projects tab.
 *
 * Business Unit Leaderboard: ranks each BU by its milestone completion
 * rate (% of that BU's milestones with status "done"). Read-only,
 * self-fetching — GET /api/dashboard/bu-leaderboard.
 */
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

const BAR_TONE = ["bg-[#F54800]", "bg-emerald-500", "bg-blue-500", "bg-purple-500", "bg-slate-400"];

export default function BuLeaderboardCard() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/dashboard/bu-leaderboard").then(({ data }) => setRows(data || [])).catch(() => setRows([]));
  }, []);

  return (
    <div className="card-flat overflow-hidden" data-testid="bu-leaderboard-card">
      <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-2">
        <Trophy size={14} className="text-[#F54800] shrink-0" />
        <div>
          <div className="font-display font-bold text-sm text-slate-900">Business Unit Leaderboard</div>
          <div className="text-[10px] text-slate-500">Milestone completion rate · highest first</div>
        </div>
      </div>
      <div className="p-4">
        {rows === null && <div className="text-sm text-slate-500">Loading…</div>}
        {rows && rows.length === 0 && (
          <div className="text-sm text-slate-500" data-testid="bu-leaderboard-empty">No milestones logged yet.</div>
        )}
        {rows && rows.length > 0 && (
          <ul className="space-y-3">
            {rows.map((r, i) => (
              <li key={r.business_unit} data-testid={`bu-leaderboard-row-${r.business_unit}`}>
                <div className="flex items-center justify-between text-sm mb-1">
                  <span className="font-medium text-slate-800 inline-flex items-center gap-1">
                    {i === 0 && <Trophy size={12} className="text-amber-500" />} {r.business_unit}
                  </span>
                  <span className="text-slate-500 text-xs font-mono">{r.done}/{r.total} · <span className="font-semibold text-slate-800">{r.completion_pct}%</span></span>
                </div>
                <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                  <div className={`h-full rounded-full ${BAR_TONE[i % BAR_TONE.length]}`} style={{ width: `${r.completion_pct}%` }} />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
